module.exports = __webpack_public_path__ + "img/szzl.7c0d0420.png";